import { HubConnection } from '@microsoft/signalr';
import { debounce } from 'lodash';

import { ArrivingFromLookupDto, FacilityDto, PatientTypeDto, RegionDto } from '@medone/medonehp-api-client';

import { SignalRDefaultDebounceOptions, SignalRDefaultDebounceTimeout } from '../../../../../Config';
import { store } from '../../../../../shared/store';
import { syncRegion } from '../slice';
import { syncArrivingFrom } from '../slice.arriving-froms';
import { fetchEventLogs } from '../slice.event-logs';
import { syncFacility } from '../slice.facilities';
import { syncPatientTypes } from '../slice.patient-types';

const onRegionAdded = (dto: RegionDto) => {
    const convertedDto = RegionDto.fromJS(dto);

    store.dispatch(syncRegion(convertedDto));
};

const onFacilityAdded = (dto: FacilityDto) => {
    const convertedDto = FacilityDto.fromJS(dto);

    store.dispatch(syncFacility(convertedDto));
};

const onPatientTypeAdded = (dto: PatientTypeDto) => {
    const convertedDto = PatientTypeDto.fromJS(dto);

    store.dispatch(syncPatientTypes(convertedDto));
};

const onArrivingFromAdded = (dto: ArrivingFromLookupDto) => {
    const convertedDto = ArrivingFromLookupDto.fromJS(dto);

    store.dispatch(syncArrivingFrom(convertedDto));
};

const onEventLogAdded = debounce(
    () => {
        const { eventLogFilter } = store.getState().admin;

        store.dispatch(fetchEventLogs(eventLogFilter));
    },
    SignalRDefaultDebounceTimeout,
    SignalRDefaultDebounceOptions
);

export const removeAdminHubConnection = (connection: HubConnection) => {
    connection.off('RegionAdded', onRegionAdded);
    connection.off('FacilityAdded', onFacilityAdded);
    connection.off('PatientTypeAdded', onPatientTypeAdded);
    connection.off('ArrivingFromAdded', onArrivingFromAdded);
    connection.off('EventLogAdded', onEventLogAdded);
};

export const initAdminHubConnection = (connection: HubConnection) => {
    connection.on('RegionAdded', onRegionAdded);
    connection.on('FacilityAdded', onFacilityAdded);
    connection.on('PatientTypeAdded', onPatientTypeAdded);
    connection.on('ArrivingFromAdded', onArrivingFromAdded);
    connection.on('EventLogAdded', onEventLogAdded);
};
